// @/utils/location/geoDistance.js

export const LOCATION_CONFIRMATION_DISTANCE_KM = 5
export const CONFIRMED_COORD_PRECISION = 2

export const toNumber = value => {
  if (value === null || value === undefined || value === '') return null

  const numberValue = Number(value)

  return Number.isFinite(numberValue) ? numberValue : null
}

export const roundCoord = value => {
  const numberValue = Number(value)

  if (!Number.isFinite(numberValue)) return null

  return Number(numberValue.toFixed(CONFIRMED_COORD_PRECISION))
}

export const isValidCoordinate = value => toNumber(value) !== null

export const normalizeCoords = geoData => {
  if (!geoData || typeof geoData !== 'object') return null

  const lat = toNumber(geoData.lat ?? geoData.latitude)
  const lng = toNumber(geoData.lng ?? geoData.lon ?? geoData.longitude)

  if (lat === null || lng === null) return null

  return { lat, lng }
}

export const normalizeStoredCoords = geoData => {
  const coords = normalizeCoords(geoData)

  if (!coords) return null

  return {
    lat: roundCoord(coords.lat),
    lng: roundCoord(coords.lng),
  }
}

export const normalizePositiveNumber = value => {
  const numberValue = Number(value)

  if (!Number.isFinite(numberValue) || numberValue <= 0) {
    return null
  }

  return numberValue
}

export const getDistanceKm = (from, to) => {
  const fromCoords = normalizeCoords(from)
  const toCoords = normalizeCoords(to)

  if (!fromCoords || !toCoords) return null

  const earthRadiusKm = 6371
  const degToRad = value => (value * Math.PI) / 180

  const dLat = degToRad(toCoords.lat - fromCoords.lat)
  const dLng = degToRad(toCoords.lng - fromCoords.lng)

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
    + Math.cos(degToRad(fromCoords.lat))
    * Math.cos(degToRad(toCoords.lat))
    * Math.sin(dLng / 2)
    * Math.sin(dLng / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return earthRadiusKm * c
}

export const isDistanceGreaterThan = (
  from,
  to,
  thresholdKm = LOCATION_CONFIRMATION_DISTANCE_KM,
) => {
  const distanceKm = getDistanceKm(from, to)

  if (distanceKm === null) return true

  return distanceKm > thresholdKm
}

export const areCoordsWithinDistance = (from, to, thresholdKm = 0.05) => {
  const distanceKm = getDistanceKm(from, to)

  if (distanceKm === null) return false

  return distanceKm <= thresholdKm
}